import { render, staticRenderFns } from "./ShareLink.vue?vue&type=template&id=6f9910d1&scoped=true&"
import script from "./ShareLink.vue?vue&type=script&lang=js&"
export * from "./ShareLink.vue?vue&type=script&lang=js&"
import style0 from "./ShareLink.vue?vue&type=style&index=0&id=6f9910d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f9910d1",
  null
  
)

export default component.exports